import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content';

import { AnalyticsContextProvider } from '@nerdwallet/structured-content/contexts/AnalyticsContext';
import {
  useSegmentAnalytics,
  useAnalyticsPageView,
} from '@nerdwallet/seo-analytics';
import {
  repeatable,
  stringInputSpec,
  boolCheckboxSpec,
} from '../../lib/editing-configs';

const InsuranceSummaryTableWrapper = ({
  marketplaceEntities = [],
  omitRating = false,
}) => {
  const marketplaceEntityIds = useMemo(
    () =>
      marketplaceEntities
        .map((marketplaceEntity) => marketplaceEntity?.id)
        .filter((marketplaceEntityId) => !!marketplaceEntityId),
    [marketplaceEntities]
  );

  const { pageViewId, pageViewReady, pageName } = useAnalyticsPageView();
  const segmentInstance = useSegmentAnalytics();

  const analytics = {
    segmentAttributes: {
      driverPageName: pageName,
      pageViewId,
      pageViewReady,
      segmentInstance: segmentInstance.analytics,
    },
  };

  if (marketplaceEntityIds?.length === 0) {
    return null;
  }

  return (
    <AnalyticsContextProvider value={analytics}>
      <StructuredContent>
        {{
          type: 'InsuranceSummaryTable',
          version: '1.0.0',
          props: {
            marketplaceEntityIds,
            withRating: !omitRating,
          },
        }}
      </StructuredContent>
    </AnalyticsContextProvider>
  );
};

InsuranceSummaryTableWrapper.propTypes = {
  marketplaceEntities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ),
  omitRating: PropTypes.bool,
};

InsuranceSummaryTableWrapper.defaultProps = {
  marketplaceEntities: [],
  omitRating: false,
};

InsuranceSummaryTableWrapper.getEditingConfig = () => {
  return [
    repeatable(
      'marketplaceEntities',
      'Marketplace Entities',
      'Makertplace Entity',
      () => [stringInputSpec('id', 'Marketplace Entity ID')]
    ),
    boolCheckboxSpec('omitRating', 'Omit Star Rating Column'),
  ];
};

InsuranceSummaryTableWrapper.displayName = 'Insurance Summary Table Wrapper';

export default InsuranceSummaryTableWrapper;
